/**
 * Branding configuration for the Popup Studio app.
 * This will be configurable per-tenant in the future.
 */
export interface BrandingConfig {
  appName: string;
  logoUrl: string | null;
  primaryColor: string;
  faviconUrl: string | null;
}

export const defaultBranding: BrandingConfig = {
  appName: 'Popup Studio',
  logoUrl: null,
  primaryColor: '#111827',
  faviconUrl: null,
};

/**
 * Get branding config. Currently returns defaults.
 * Future: fetch from API based on tenant/subdomain.
 */
export function getBranding(): BrandingConfig {
  return defaultBranding;
}
